import * as React from "react";
import { APP_CONFIG } from "../constants/authConfig";

export default function SubscriptionPanel({
  hasAccess,
  isTrial,
  subscriptionEndDate,
  onSubscribe,
}) {
  if (hasAccess && !isTrial) {
    return (
      <section className="card !rounded-none !border-x-0 !p-3">
        <div className="flex items-center justify-between gap-2">
          <div>
            <p className="eyebrow">Subscription</p>
            <p className="text-xs text-slate-600">
              Active{subscriptionEndDate ? ` until ${subscriptionEndDate}` : ""}
            </p>
          </div>
          <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-medium text-emerald-700">
            Pro
          </span>
        </div>
      </section>
    );
  }

  if (hasAccess && isTrial) {
    return (
      <section className="card space-y-2 !rounded-none !border-x-0 !p-3">
        <div className="flex items-center justify-between gap-2">
          <div>
            <p className="eyebrow">Subscription</p>
            <p className="text-xs text-slate-600">
              Free trial{subscriptionEndDate ? ` until ${subscriptionEndDate}` : ""}
            </p>
          </div>
          <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-medium text-amber-700">
            Trial
          </span>
        </div>
        <p className="text-[10px] leading-4 text-slate-500">
          Upgrade anytime. Use the same email on PayPal.
        </p>
        <button type="button" className="btn-primary !py-2 text-xs" onClick={onSubscribe}>
          Upgrade with PayPal
        </button>
      </section>
    );
  }

  return (
    <section className="card space-y-2 !rounded-none !border-x-0 !p-3">
      <div className="flex items-center justify-between gap-2">
        <div>
          <p className="eyebrow">Subscription</p>
          <p className="text-xs text-slate-600">No active subscription found for this email.</p>
        </div>
        <span className="rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-medium text-red-700">
          Expired
        </span>
      </div>
      <p className="text-[10px] leading-4 text-red-600">
        PayPal email must match the email entered above.
      </p>
      <button type="button" className="btn-primary !py-2 text-xs" onClick={onSubscribe}>
        Subscribe with PayPal
      </button>
      <p className="text-[10px] leading-4 text-slate-500">
        Need help?{" "}
        <a href={`mailto:${APP_CONFIG.supportEmail}`} className="text-brand-700 underline">
          {APP_CONFIG.supportEmail}
        </a>
      </p>
    </section>
  );
}
